require('videogular');
require('./vg-overlay-play');

module.exports = 'com.2fdevs.videogular.plugins.overlayplay';



// WEBPACK FOOTER //
// ./node_modules/videogular-overlay-play/index.js